import React from "react";
import BarekamText from "../../../../../../components/text";
import {MenuItem} from "@mui/material";
import {Message, MessageSections} from "../../../../../../components/message/message";
import {BarekamSelect} from "../../../../../../components/select/select";

const TaxesFilter = (props: TaxesFilterProps) => {
    const {withTaxes, onFilterChange} = props;

    return (
        <BarekamSelect
            variant={'outlined'}
            label={<Message messageKey={'taxes'} sectionId={MessageSections.ORDERS}/>}
            value={withTaxes === undefined ? 'all' : '' + withTaxes}
            type={"filter"}
            fullWidth
            required>
            <MenuItem onClick={() => onFilterChange(undefined)}
                            value={'all'}
                            key={'all'}>
                <BarekamText variant={"m"}>
                    <Message messageKey={"all"} sectionId={MessageSections.ORDERS}/>
                </BarekamText>
            </MenuItem>

            <MenuItem onClick={() => onFilterChange(true)}
                            value={'true'}
                            key={'with_taxes'}>
                <BarekamText variant={"m"}>
                    <Message messageKey={"with_taxes"} sectionId={MessageSections.ORDERS}/>
                </BarekamText>
            </MenuItem>

            <MenuItem onClick={() => onFilterChange(false)}
                            value={'false'}
                            key={'without_taxes'}>
                <BarekamText variant={"m"}>
                    <Message messageKey={"without_taxes"} sectionId={MessageSections.ORDERS}/>
                </BarekamText>
            </MenuItem>
        </BarekamSelect>
    );
};

export default TaxesFilter;

interface TaxesFilterProps {
    withTaxes: boolean | undefined;
    onFilterChange: (onlyWithTaxes: boolean | undefined) => void;
}
